module.exports = __webpack_public_path__ + "static/carousel-01@2x-3637df97faf6d55f2d0c80018d6e6bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-01@2x.jpg
// module id = 2518
// module chunks = 168707334958949